import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useOrg() {
  const [regions, setRegions] = useState([]);
  const [communities, setCommunities] = useState([]);

  const reload = async () => {
    const [r, c] = await Promise.all([api.get("/regions"), api.get("/communities")]);
    setRegions(r.data);
    setCommunities(c.data);
  };

  useEffect(() => {
    reload();
  }, []);

  return { regions, communities, reload };
}
